// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const UserType = {
  "PRODUCER": "Producer",
  "INSTRUCTOR": "Instructor",
  "ADMINISTRATOR": "Administrator"
};

const Varieties = {
  "KOUSUI": "kousui",
  "HOUSUI": "housui",
  "AKIZUKI": "akizuki",
  "NIITAKA": "niitaka",
  "OTHERS": "others"
};

const DiagnoseType = {
  "VEGETATION_COVERAGE": "vegetationCoverage",
  "FLOWERING_RATE": "floweringRate",
  "BEARING_NUMBER": "bearingNumber",
  "FRUIT_SIZE": "fruitSize",
  "FRUIT_MAX_SIZE": "fruitMaxSize",
  "FRUIT_MIN_SIZE": "fruitMinSize",
  "BRANCH_LENGTH": "branchLength"
};

const Category = {
  "FRUITS_THINNING": "fruitsThinning",
  "PESTICIDE_SPRAYNING": "pesticideSprayning",
  "MATING": "mating",
  "HARVEST": "harvest",
  "FLOWERING": "flowering",
  "OTHERS": "others"
};

const EventCategories = {
  "FRUITS_THINNING": "fruitsThinning",
  "PESTICIDE_SPRAYNING": "pesticideSprayning",
  "MATING": "mating",
  "HARVEST": "harvest",
  "FLOWERING": "flowering",
  "OTHERS": "others"
};

const { AppUser, UserGroup, Farm, Photo, Diagnosis, PhotoComment, DayDiagnosis, DayDiagnoseComment, DiagnosisSummary, DailyLog, MonthReport, CultivationEvent, GroupConversation, Conversation, UserConversation, Message, SendPicture, Cooperation, Friendship } = initSchema(schema);

export {
  AppUser,
  UserGroup,
  Farm,
  Photo,
  Diagnosis,
  PhotoComment,
  DayDiagnosis,
  DayDiagnoseComment,
  DiagnosisSummary,
  DailyLog,
  MonthReport,
  CultivationEvent,
  GroupConversation,
  Conversation,
  UserConversation,
  Message,
  SendPicture,
  Cooperation,
  Friendship,
  UserType,
  Varieties,
  DiagnoseType,
  Category,
  EventCategories
};